import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredDialogComponent } from '../components/session-expired-dialog/session-expired-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredDialogService {
  private dialogOpen = false;

  constructor(private dialog: MatDialog) {}

  open(): void {
    if (this.dialogOpen || this.isLoginScreen()) {
      return;
    }

    this.dialogOpen = true;
    const ref = this.dialog.open(SessionExpiredDialogComponent, {
      disableClose: true,
      width: '420px',
      maxWidth: 'calc(100vw - 24px)',
      panelClass: 'session-expired-panel',
      autoFocus: false
    });

    ref.afterClosed().subscribe(() => {
      this.dialogOpen = false;
    });
  }

  /** A 401 on the login screens means bad credentials or no permission, not an expired session. */
  private isLoginScreen(): boolean {
    const path = (window.location.hash || '').replace(/^#/, '').split('?')[0];
    return path === '' || path === '/' || path.startsWith('/login') || path.startsWith('/external-login');
  }
}
